import * as GETTER from './getter-types'

export default {
    [GETTER.GET_SCRAPER]: (state) => state.scraper,
    [GETTER.GET_SCRAPED_INFORMATION]: (state) => state.scrapedInformation
}
